// src/utils/utc-date.js

/**
 * Converte uma data UTC para uma string no formato YYYY-MM-DDTHH:mm
 * em um fuso horário específico.
 *
 * @param {string} utcDateString - Data em UTC (ex: "2025-09-18T22:00:00.000000Z")
 * @param {string} timeZone - Fuso horário IANA (ex: "America/Sao_Paulo", "UTC")
 * @returns {string} Data formatada (ex: "2025-09-18T19:00")
 */
 export function convertUtcToLocal(utcDateString, timeZone = "America/Sao_Paulo") {
    const date = new Date(utcDateString);
  
    const formatter = new Intl.DateTimeFormat("sv-SE", {
      year: "numeric",
      month: "2-digit",
      day: "2-digit",
      hour: "2-digit",
      minute: "2-digit",
      hour12: false,
      timeZone
    });
  
    return formatter.format(date).replace(" ", "T");
  }